import { calculateIfSarcasmIsEnabled,
  calculateSarcasmThreshold,
  calculateHarmWatchFromDate,
  calculateHarmWatchToDate } from './globalUtils';

const BACKEND_PREFIX = 'backend/';
const ADMIN_API_PREFIX = BACKEND_PREFIX + 'admin/';
export const apiEndPoints = {
  charts: {
    RETRIEVE_CHARTS: BACKEND_PREFIX + 'charts',
    RETRIEVE_CHART_BY_ID: BACKEND_PREFIX + 'chart?chartId=',
    UPDATE_SELECTED_CHARTS: BACKEND_PREFIX + 'charts',
  },
  labels: {
    RETRIEVE_EVENT_LABELS_BY_CHART_ID: BACKEND_PREFIX + 'eventLabels?chartId=',
    EVENT_LABEL_PREFIX: BACKEND_PREFIX + 'eventLabels',
  },
  topics: {
    RETRIEVE_TOPICS: BACKEND_PREFIX + 'topics',
    CREATE_TOPICS: BACKEND_PREFIX + 'topics',
    UPDATE_TOPICS: BACKEND_PREFIX + 'topics',
    DELETE_TOPIC: BACKEND_PREFIX + 'topics',
    UPDATE_SELECTED_TOPIC: BACKEND_PREFIX + 'topic',
  },
  topicpreview: {
    RETRIEVE_TOPIC_PREVIEW: BACKEND_PREFIX + 'topicpreview',
  },
  categories: {
    RETRIEVE_CATEGORIES: BACKEND_PREFIX + 'categories',
  },
  uploadFile: {
    UPLOAD_FILE: BACKEND_PREFIX + 'uploadedFile',
  },
  uploadedFiles: {
    UPLOADED_FILES: BACKEND_PREFIX + 'uploadedFiles'
  },
  sources: {
    RETRIEVE_SOURCES: BACKEND_PREFIX + 'sources',
    UPDATE_SOURCES: BACKEND_PREFIX + 'sources',
  },
  topicsDropDown: {
    UPDATE_SELECTED_TOPIC: BACKEND_PREFIX + 'topicdropdown',
    RETRIEVE_TOPICDROPDOWN: BACKEND_PREFIX + 'topicdropdown',
    UPDATE_TOPICDROPDOWN: BACKEND_PREFIX + 'topicdropdown',
  },
  comments: {
    RETRIEVE_COMMENTS: BACKEND_PREFIX + 'comments',
    UPDATE_COMMENT_RELEVANT: BACKEND_PREFIX + 'comment',
    UPDATE_COMMENT_IS_SARCASM_MANUALLY_TOGGLED: BACKEND_PREFIX + 'comment',
  },
  tweets: {
    RETRIEVE_TWEETS: BACKEND_PREFIX + 'tweets',
    UPDATE_TWEET_RELEVANT: BACKEND_PREFIX + 'tweets',
    UPDATE_TWEET_IS_SARCASM_MANUALLY_TOGGLED: BACKEND_PREFIX + 'tweets',
  },
  headlines: {
    RETRIEVE_HEADLINES: BACKEND_PREFIX + 'headlines',
    UPDATE_HEADLINE_RELEVANT: BACKEND_PREFIX + 'headlines',
  },
  feeds: {
    RETRIEVE_FEEDS: BACKEND_PREFIX + 'feeds',
    UPDATE_FEED_RELEVANT: BACKEND_PREFIX + 'feed',
    RETRIEVE_FEED_DETAILS: BACKEND_PREFIX + 'feed',
  },
  uploadedComments: {
    RETRIEVE_UPLOADED_COMMENTS: BACKEND_PREFIX + 'uploadedComments'
  },
  shareReport: {
    RETRIEVE_REPORT_STATUS: BACKEND_PREFIX + 'share',
    SEND_SHARE_REPORT: BACKEND_PREFIX + 'share',
  },
  compare: {
    RETRIEVE_COMPARE: BACKEND_PREFIX + 'compare',
  },
  csv: {
    RETRIEVE_CSV: BACKEND_PREFIX + 'csv',
  },
  contact: {
    SEND_MESSAGE: BACKEND_PREFIX + 'contact',
  },
  reports: {
    CREATE_REPORT: BACKEND_PREFIX + 'reports',
    UPDATE_REPORT: BACKEND_PREFIX + 'reports',
    RETRIEVE_REPORTS: BACKEND_PREFIX + 'reports',
    DELETE_REPORTS: BACKEND_PREFIX + 'reports',
  },
  facebook: {
    ROOT_URL: 'https://graph.facebook.com/v6.0/',
  },
  facebook_connection: {
    CHECK_CONNECTION: BACKEND_PREFIX + 'facebook_connection',
    UPDATE_CONNECTION: BACKEND_PREFIX + 'facebook_connection',
    DELETE_CONNECTION: BACKEND_PREFIX + 'facebook_connection',
  },
  authentication: {
    LOGIN: BACKEND_PREFIX + 'auth/login',
    CHANGE_MY_PASSWORD: BACKEND_PREFIX + 'auth/change_my_password',
    SEND_PASSWORD_RESET_EMAIL: BACKEND_PREFIX + 'auth/send_password_reset_email',
    RESET_PASSWORD: BACKEND_PREFIX + 'auth/reset_password',
    CHECK_TOKEN: BACKEND_PREFIX + 'auth/check_token'
  },
  userManagement: {
    GET_ALL_USERS: ADMIN_API_PREFIX + 'userManagement',
    ADD_USER: ADMIN_API_PREFIX + 'userManagement',
    PATCH_USER: ADMIN_API_PREFIX + 'userManagement',
    DELETE_USER: ADMIN_API_PREFIX + 'userManagement',
  },
};

export const APP_ROUTES = {
  DASHBOARD: 'dashboard',
  USER_MANAGEMENT: 'user-management',
};

export const TIME_TO_SLEEP_BETWEEN_CHECKS_IF_FIREBASE_AUTH_INFO_IS_READY = 50;

export const IS_SARCASM_ENABLED = calculateIfSarcasmIsEnabled();
export const SARCASM_THRESHOLD = calculateSarcasmThreshold();
export const SARCASM_THRESHOLD_PERCENTAGE = SARCASM_THRESHOLD * 100;
export const HARM_WATCH_FROM_DATE = calculateHarmWatchFromDate();
export const HARM_WATCH_TO_DATE = calculateHarmWatchToDate();
export const CONSTRUCTIVENESS_THRESHOLD = 0.5;
export const MINIMUM_CONSTRUCTIVENESS_SCORE = 0.0;

export const USER_ROLES = {
  ADMIN: 'admin',
  DATA_ANALYST: 'data_analyst'
}

export const TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS = 4000;


// WEBPACK FOOTER //
// ./src/common/globalConstants.js